(function () {
  'use strict';
  if (window.__mtnBikeAckLoaded) return;
  window.__mtnBikeAckLoaded = true;

  var IDS = (window.MTN_BIKE_ACK_IDS || []).map(String);
  if (!IDS.length) return;

  var PROP = 'Order acknowledgement';
  var ERROR = 'Please check the box to acknowledge before adding this item to your cart.';
  var CART_ERROR = 'Your cart has an item that is missing its order acknowledgement. Please open the product page, check the box and add it again.';
  var ORANGE = '#f5821f';
  var GREEN = '#2ea44f';
  var state = { agreed: false };
  var raf = null;
  var passThrough = false;

  var st = document.createElement('style');
  st.id = 'mtn-bike-ack-style';
  st.textContent =
    '.mtn-bike-ack{margin:10px 0;padding:8px 10px;border:1px solid ' + ORANGE + ';border-radius:6px;font-size:0.75rem;line-height:1.35;transition:border-color .2s ease,background-color .2s ease}' +
    '.mtn-bike-ack.is-agreed{border-color:' + GREEN + ';background-color:rgba(46,164,79,0.1)}' +
    '.mtn-bike-ack__label{display:flex;gap:8px;align-items:center;cursor:pointer}' +
    '.mtn-bike-ack__label input{-webkit-appearance:none;appearance:none;position:relative;flex:0 0 auto;width:16px;height:16px;margin:0;border:2px solid ' + ORANGE + ';border-radius:4px;background:transparent;cursor:pointer;transition:background-color .2s ease,border-color .2s ease}' +
    '.mtn-bike-ack__label input:checked{background:' + GREEN + ';border-color:' + GREEN + '}' +
    '.mtn-bike-ack__label input:checked::after{content:"";position:absolute;left:3.5px;top:0.5px;width:4px;height:8px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}' +
    '.mtn-bike-ack__error{margin:6px 0 0;color:#ff8a80;font-size:0.75rem}' +
    '.mtn-bike-ack__error[hidden]{display:none}' +
    '.mtn-bike-ack-overlay{position:absolute;inset:0;z-index:5;cursor:not-allowed;background:transparent}' +
    '.mtn-bike-ack-overlay[hidden]{display:none}';
  document.head.appendChild(st);

  function isBike(id) {
    for (var i = 0; i < IDS.length; i++) { if (IDS[i] === String(id)) return true; }
    return false;
  }

  function isBikeForm(pf) {
    return !!(pf && pf.getAttribute && !pf.closest('.quick-add') && isBike(pf.getAttribute('data-product-id')));
  }

  function cardUrl(el) {
    var n = el;
    for (var i = 0; n && n !== document.body && i < 10; i++) {
      var a = n.querySelector('a[href*="/products/"]');
      if (a) return a.href;
      n = n.parentElement;
    }
    return null;
  }

  function showError(msg) {
    var els = document.querySelectorAll('.mtn-bike-ack__error');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = msg || ERROR;
      els[i].hidden = false;
    }
    var boxes = document.querySelectorAll('.mtn-bike-ack');
    if (boxes.length) boxes[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function hideErrors() {
    var els = document.querySelectorAll('.mtn-bike-ack__error');
    for (var i = 0; i < els.length; i++) els[i].hidden = true;
  }

  function syncBoxes() {
    var c = document.querySelectorAll('.mtn-bike-ack-input');
    for (var i = 0; i < c.length; i++) {
      c[i].checked = state.agreed;
      var box = c[i].closest('.mtn-bike-ack');
      if (box) box.classList.toggle('is-agreed', state.agreed);
    }
  }

  function refresh() {
    var o = document.querySelectorAll('.mtn-bike-ack-overlay');
    for (var i = 0; i < o.length; i++) {
      var c = o[i].parentNode;
      o[i].hidden = state.agreed;
      for (var k = 0; k < c.children.length; k++) {
        if (c.children[k] !== o[i]) c.children[k].inert = !state.agreed;
      }
    }
  }

  function onChange(e) {
    state.agreed = !!e.target.checked;
    hideErrors();
    syncBoxes();
    refresh();
  }

  function makeBox() {
    var box = document.createElement('div');
    box.className = 'mtn-bike-ack' + (state.agreed ? ' is-agreed' : '');
    var label = document.createElement('label');
    label.className = 'mtn-bike-ack__label';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'mtn-bike-ack-input';
    cb.name = 'properties[' + PROP + ']';
    cb.value = 'Agreed';
    cb.checked = state.agreed;
    cb.addEventListener('change', onChange);
    var span = document.createElement('span');
    span.textContent = 'I acknowledge I have read and confirm the order requirements, specifications, and delivery details for this listing.';
    label.appendChild(cb);
    label.appendChild(span);
    var err = document.createElement('p');
    err.className = 'mtn-bike-ack__error';
    err.setAttribute('role', 'alert');
    err.hidden = true;
    err.textContent = ERROR;
    box.appendChild(label);
    box.appendChild(err);
    return box;
  }

  function gate(el) {
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    if (!el.querySelector(':scope > .mtn-bike-ack-overlay')) {
      var o = document.createElement('div');
      o.className = 'mtn-bike-ack-overlay';
      o.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showError();
      });
      el.appendChild(o);
    }
  }

  function scan() {
    var pfs = document.querySelectorAll('product-form-component[data-product-id]');
    for (var k = 0; k < pfs.length; k++) {
      var pf = pfs[k];
      if (!isBikeForm(pf)) continue;
      var row = pf.querySelector('.product-form-buttons');
      if (!row) continue;
      if (!pf.querySelector('.mtn-bike-ack')) row.parentNode.insertBefore(makeBox(), row);
      var ab = pf.querySelector('.accelerated-checkout-block');
      if (ab) gate(ab);
    }
    refresh();
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; scan(); });
  }

  function pageHasBikeBox() {
    return !!document.querySelector('.mtn-bike-ack');
  }

  function onClickCapture(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var qb = t.closest('.quick-add__button');
    if (qb) {
      var qa = qb.closest('quick-add-component');
      var pid = qa && qa.getAttribute('data-product-id');
      if (pid && isBike(pid)) {
        var url = cardUrl(qa);
        if (url) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = url;
          return;
        }
      }
    }

    var addBtn = t.closest('product-form-component button[type=submit], product-form-component button[name=add]');
    if (addBtn && isBikeForm(addBtn.closest('product-form-component')) && !state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
      return;
    }

    var sticky = t.closest('[class*="sticky-add-to-cart"], sticky-add-to-cart');
    if (sticky && t.closest('button, a') && pageHasBikeBox() && !state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
      return;
    }

    var btn = t.closest('#checkout, button[name=checkout], a[href^="/checkout"]');
    if (!btn || passThrough) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = false;
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          if (isBike(items[i].product_id) && !(items[i].properties && items[i].properties[PROP])) bad = true;
        }
        if (bad) {
          window.alert(CART_ERROR);
          return;
        }
        passThrough = true;
        btn.click();
        setTimeout(function () { passThrough = false; }, 1500);
      })
      .catch(function () {
        passThrough = true;
        btn.click();
        setTimeout(function () { passThrough = false; }, 1500);
      });
  }

  function onSubmitCapture(e) {
    var f = e.target;
    var pf = f && f.closest && f.closest('product-form-component');
    if (pf && isBikeForm(pf) && !state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }

  window.addEventListener('click', onClickCapture, true);
  window.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var addBtn = t.closest('product-form-component button[type=submit], product-form-component button[name=add]');
    if (addBtn && isBikeForm(addBtn.closest('product-form-component')) && !state.agreed) { e.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('submit', onSubmitCapture, true);

  document.addEventListener('change', function () { setTimeout(refresh, 0); });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
